<form [formGroup]="menuService?.form" (ngSubmit)="saveAndContinue()" class="px-0 px-sm-3"
    [ngClass]="{ 'py-5 position-relative': isDialog }">
    <div class="container-fluid">
        <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" *ngIf="isDialog"
            (click)="closeDialog()"></i>
        <h4 *ngIf="isDialog" class="text-bold text-center px-3">
            {{ dialogTitle }}
        </h4>

        <section class="transport-change-job" *ngIf="showTransportCompanyChangeJob">
            <ng-container *ngIf="isLoadingTransportCompanyChangeJob">
                <div class="transport-change-job__loading">
                    <div class="transport-change-job__icon transport-change-job__icon--loading">
                        <i class="fas fa-sync-alt fa-spin"></i>
                    </div>
                    <div>
                        <h5 class="text-bold mb-1">Consultando el proceso en curso</h5>
                        <p class="mb-0">Estamos obteniendo el último estado reportado por el backend.</p>
                    </div>
                </div>
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </ng-container>

            <div class="transport-change-job__error"
                *ngIf="!isLoadingTransportCompanyChangeJob && transportCompanyChangeJobError">
                <div class="transport-change-job__icon transport-change-job__icon--failed">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div>
                    <h5 class="text-bold mb-1">No pudimos consultar el proceso</h5>
                    <p class="mb-0">{{ transportCompanyChangeJobError }}</p>
                </div>
            </div>

            <ng-container *ngIf="!isLoadingTransportCompanyChangeJob && transportCompanyChangeJob">
                <div class="transport-change-job__header">
                    <div class="transport-change-job__icon"
                        [ngClass]="'transport-change-job__icon--' + transportCompanyChangeJobStatusClass">
                        <i class="fas"
                            [ngClass]="{
                                'fa-check': transportCompanyChangeJobStatus === 'DONE',
                                'fa-times': transportCompanyChangeJobStatus === 'FAILED',
                                'fa-cog fa-spin': transportCompanyChangeJobStatus !== 'DONE' && transportCompanyChangeJobStatus !== 'FAILED'
                            }"></i>
                    </div>
                    <div class="transport-change-job__summary">
                        <div class="transport-change-job__title-row">
                            <h5 class="text-bold mb-0">{{ transportCompanyChangeJobTitle }}</h5>
                            <span class="transport-change-job__status"
                                [ngClass]="'transport-change-job__status--' + transportCompanyChangeJobStatusClass">
                                {{ transportCompanyChangeJobStatusLabel }}
                            </span>
                        </div>
                        <p class="mb-0 mt-1">{{ transportCompanyChangeJobStatusDescription }}</p>
                    </div>
                </div>

                <mat-progress-bar class="transport-change-job__progress"
                    [ngClass]="'transport-change-job__progress--' + transportCompanyChangeJobStatusClass"
                    mode="determinate" [value]="transportCompanyChangeJobProgress">
                </mat-progress-bar>

                <div class="transport-change-job__details">
                    <div *ngIf="transportCompanyChangeCurrentStepLabel">
                        <span class="transport-change-job__detail-label">Paso actual</span>
                        <strong>{{ transportCompanyChangeCurrentStepLabel }}</strong>
                    </div>
                    <div>
                        <span class="transport-change-job__detail-label">ID del proceso</span>
                        <strong class="transport-change-job__job-id">{{ transportCompanyChangeJob?.id }}</strong>
                    </div>
                </div>

                <div class="transport-change-job__documents"
                    *ngIf="cancelledTransportDocuments.length || recreatedTransportDocuments.length">
                    <div *ngIf="cancelledTransportDocuments.length">
                        <span class="transport-change-job__detail-label">Documentos anulados</span>
                        <div>
                            <span class="transport-change-job__document transport-change-job__document--cancelled"
                                *ngFor="let document of cancelledTransportDocuments">
                                <i class="fas fa-check mr-1"></i>{{ document }}
                            </span>
                        </div>
                    </div>
                    <div *ngIf="recreatedTransportDocuments.length">
                        <span class="transport-change-job__detail-label">Documentos recreados</span>
                        <div>
                            <span class="transport-change-job__document transport-change-job__document--recreated"
                                *ngFor="let document of recreatedTransportDocuments">
                                <i class="fas fa-check mr-1"></i>{{ document }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="alert alert-danger mb-0 mt-3" role="alert"
                    *ngIf="transportCompanyChangeJobStatus === 'FAILED' && transportCompanyChangeJob?.error">
                    <strong class="text-bold">Detalle del error:</strong>
                    {{ transportCompanyChangeJob?.error }}
                </div>

                <div class="transport-change-job__notice">
                    <i class="fas fa-info-circle mr-2"></i>
                    <span>
                        Este es el último estado recibido. El proceso continúa en segundo plano y cerrar este diálogo no
                        lo cancela.
                    </span>
                </div>
            </ng-container>

            <div class="transport-change-job__actions"
                *ngIf="!isLoadingTransportCompanyChangeJob && activeTransportCompanyChangeJobId">
                <button mat-stroked-button color="primary" type="button"
                    [disabled]="isRefreshingTransportCompanyChangeJob"
                    (click)="refreshTransportCompanyChangeJob()">
                    <i class="fas fa-sync-alt mr-2"
                        [ngClass]="{'fa-spin': isRefreshingTransportCompanyChangeJob}"></i>
                    {{ isRefreshingTransportCompanyChangeJob ? 'Actualizando estado...' : 'Actualizar estado' }}
                </button>
            </div>
        </section>

        <div class="row" *ngIf="canSeeGeneralData && !showTransportCompanyChangeJob">
            <ng-container *ngIf="showAdditionalInformationSection">
                <p class="col-12 my-3 text-bold">
                    Tipo de viaje
                </p>
                <div class="col-md-6 mb-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Tipo de viaje<span class="asterisk">*</span></mat-label>
                        <mat-select [formControl]="tripTypeControl">
                            <mat-option *ngFor="let type of tripTypes" [value]="type.name" [disabled]="!type.isValid"
                                [matTooltip]="type.error" matTooltipClass="tooltip__error" matTooltipPosition="right">
                                {{ type.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="tripTypeControl.errors?.required">
                            {{ utils.giveMessageError('MANDATORY_FIELD') }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 mb-3" *ngIf="showMinistrySelector">
                    <label class="text-strong mr-3">Requiere manifiesto de carga</label>
                    <mat-button-toggle-group #group="matButtonToggleGroup" [formControl]="ministryControl">
                        <mat-button-toggle [value]="true">Si</mat-button-toggle>
                        <mat-button-toggle [value]="false">No</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <mat-form-field appearance="outline" class="col-md-6">
                    <mat-label>
                        Código identificador de cliente
                        <span class="optional">(opcional)</span>
                    </mat-label>
                    <input matInput type="text" [formControl]="numberDocumentSenderControl">
                    <i matSuffix class="fas fa-info-circle color-secondary-dark cursor-pointer"
                        matTooltip="Es el número del documento interno de identificación del cliente."
                        matTooltipClass="tooltip__alert" matTooltipPosition="right"></i>
                </mat-form-field>
            </ng-container>

            <ng-container *ngIf="showContractorTransportSection">
                <p class="col-12 my-3">
                    <span class="text-bold">Contratante del servicio</span>
                    ({{menuService.isEscortedService() || menuService.isSatelliteLockService()
                    ? 'Cliente interno'
                    : 'Propietario del servicio / Generador de carga / Contratante '}})
                </p>
                <div class="col-12 contractor-transport-section"
                    [ngClass]="{'contractor-transport-section--dialog': isContractorTransportDialog}">
                    <div class="row">
                        <div class="col-12" [ngClass]="{'col-md-6': ministryControl.value || isContractorTransportDialog}">
                            <app-select-company class="d-block w-100" [options]="companyOptions"
                                [inputFormControl]="companyControl" [validate]="companyValidate">
                            </app-select-company>
                        </div>
                        <app-autocomplete-thirdparty-address class="col-md-6 mb-3"
                            *ngIf="ministryControl?.value && companyControl?.value?.companyId"
                            [inputFormControl]="cargoOwnerAddressControl" [validate]="cargoOwnerAddressValidate" [options]="{
                                title: 'Dirección del contratante',
                                appearance: 'outline',
                                companyId: companyControl?.value?.companyId,
                                thirdParty: companyControl?.value ? {
                                    document: companyControl?.value?.companyId,
                                    documentType: '3',
                                    name: companyControl?.value?.name
                                } : null,
                                initialBranchOffice: menuService?.form?.get('cargoOwner.branchOffice')?.value,
                                showEditAddress: false
                            }" (emitToParent)="onCargoOwnerAddressSelected()">
                        </app-autocomplete-thirdparty-address>
                        <app-select-transport-company class="col-md-6"
                            *ngIf="requiresTransportCompany && companyControl?.value?.companyId"
                            [inputFormControl]="transportCompanyControl" [options]="{
                                appearance: 'outline',
                                disabled: !canEditGeneralData,
                                enforceChangePermission: true
                            }">
                        </app-select-transport-company>
                        <div class="col-md-4" *ngIf="ministryControl.value && cargoOwnerAddressControl?.value?.address?.id">
                            <small>Código de sede</small>
                            <h5 class="text-bold p-0 pt-1">{{cargoOwnerAddressControl?.value?.address?.id}}</h5>
                        </div>
                    </div>
                    <div class="alert alert-warning contractor-transport-section__alert"
                        *ngIf="willRecreateRndcDocuments && hasContractorOrTransportCompanyChanged" role="alert">
                        <i class="fas fa-exclamation-triangle"></i>
                        Las remesas, el manifiesto y el cumplido asociados se van a anular y a recrear automáticamente
                        con la nueva información.
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="row" *ngIf="canSeeTags && showAdditionalInformationSection">
            <p class="col-12 my-3 text-bold">Etiquetas</p>
            <div class="col-md-6 col-lg-4 mb-3" *ngFor="let tag of tagsSaved; let i = index">
                <div class="tag-card">
                    <p class="text-bold">{{tag}}</p>
                    <mat-icon *ngIf="canEditTags && tagControl.enabled" class="close-icon"
                        (click)="clearTag(i)">close</mat-icon>
                </div>
            </div>

            <mat-form-field appearance="outline" class="col-md-6 col-lg-4">
                <mat-label>Seleccionar etiqueta<span class="optional">(opcional)</span></mat-label>
                <mat-select [formControl]="tagControl" (selectionChange)="selectTag($event)">
                    <mat-option *ngFor="let tag of tags" [value]="tag.name"
                        [disabled]="menuService?.form?.get('labels')?.value?.includes(tag.name)">
                        {{tag.name}}
                    </mat-option>
                </mat-select>
                <i matPrefix class="fas fa-info-circle color-secondary-dark cursor-pointer"
                    matTooltip="Las etiquetas son identificadores que se le asignan al servicio."
                    matTooltipClass="tooltip__alert"></i>
            </mat-form-field>
        </div>
        <div *ngIf="!canSeeTags && !canSeeGeneralData" class="no-permission-container">
            <i class="fas fa-exclamation-circle fa-lg m-2"></i>
            <h4 class="text-bold">No tienes permiso para acceder a esta información. Contacta a tu administrador para
                solicitar acceso.</h4>
        </div>
        <div class="button-container mt-4" *ngIf="!isDialog; else dialogButtons">
            <button mat-raised-button color="primary" type="button" class="bg-color-primary"
                *ngIf="!canEditTags && !canEditGeneralData" (click)="continueToNextStep()">
                Continuar
            </button>
            <button mat-raised-button color="primary" type="submit" class="bg-color-primary"
                *ngIf="canEditTags || canEditGeneralData">
                Guardar y Continuar
            </button>
        </div>
        <ng-template #dialogButtons>
            <div class="button-container mt-4">
                <button class="mx-2" type="button" mat-raised-button color="primary"
                    *ngIf="showTransportCompanyChangeJob" (click)="closeDialog()">
                    Cerrar
                </button>
                <button class="mx-2" type="submit" mat-raised-button color="accent"
                    [class.contractor-transport-section__save-button]="isContractorTransportDialog"
                    [disabled]="isSubmittingTransportCompanyChange"
                    *ngIf="!showTransportCompanyChangeJob && (canEditTags || canEditGeneralData)">
                    <i class="fas fa-circle-notch fa-spin mr-2" *ngIf="isSubmittingTransportCompanyChange"></i>
                    {{ isSubmittingTransportCompanyChange
                        ? (willRecreateRndcDocuments ? 'Programando cambio...' : 'Guardando...')
                        : 'Guardar cambios' }}
                </button>
            </div>
        </ng-template>
    </div>
</form>
